import noop from 'lodash/noop';
import { ReactElement } from 'react';

import { Icd10Code } from '@dreryk/egabinet-icd-dictionary-published-language-api';
import { VisitDiagnosisRemoveCommand } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { ActionEventInterceptor } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { ChronicDiseaseRemovalParameters } from '../removalChronicDisease/RemovalChronicDiseaseModal.types';

import { useRetryActionAfterChronicDiseaseCannotBeRemovedWithoutReasonFault } from './shared/useRetryActionAfterChronicDiseaseCannotBeRemovedWithoutReasonFault';
import { VisitDiagnosisCommonFault } from './shared/useVisitDiagnosisFaultHandlerMap';

type VisitDiagnosisRemoveEventInterceptorProps = {
   readonly children: ReactElement;
   readonly visitId: number;
   readonly code: string;
};

// eslint-disable-next-line max-lines-per-function
export const VisitDiagnosisRemoveEventInterceptor = (props: VisitDiagnosisRemoveEventInterceptorProps): JSX.Element => {
   const { executeAsync: remove } = useCqrsCommand<
      void,
      ChronicDiseaseRemovalParameters | void,
      VisitDiagnosisCommonFault
   >(
      (parameters) => {
         const command = new VisitDiagnosisRemoveCommand();
         command.visitId = props.visitId;
         command.code = Icd10Code.of(props.code);
         if (parameters) {
            command.removalDate = Choice.of(parameters.chronicDiseaseRemovalDate!);
            command.removalReason = Choice.of(parameters.chronicDiseaseRemovalReason!);
         }
         return command;
      },
      {
         onUnexpectedError: noop,
      }
   );

   return (
      <ActionEventInterceptor action={useRetryActionAfterChronicDiseaseCannotBeRemovedWithoutReasonFault(remove)}>
         {props.children}
      </ActionEventInterceptor>
   );
};
